<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card
              class="card"
              
              style="
                height: 240px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">本月故障完成率</el-col>
                  </div>
                   <div>
                    <el-col :span="8">
                      <i class="el-icon-more" style="float:right;" @click="add_fau_tab()" @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :class="{ 'hovered': isHovered }"></i>
                    </el-col>
                  </div>
                </el-row>
                
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="4">
                      <el-avatar style="background: rgba(98, 54, 255, 1);"  shape="square" :size="50">
                        <i :class="['el-icon-font','el-icon-taizhanguzhang']"></i>
                      </el-avatar>
                    </el-col>
                    <el-col :span="20">
                      <span style="font-size: 40px; margin-left: 20px;">{{info.faultFinishRatio}}%</span>
                    </el-col>
                  </div>
                </el-row>
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="12">
                      <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">发生故障：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.faultCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                    <el-col :span="12">
                     <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">解决故障：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.monthHappenFaultCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                  </div>
                </el-row>
                
  
              </el-col>
             <row>
              <div id="fauChart" style="height:100%;width:100%;margin-top: 120px;"></div>   
              </row>
            </el-card>
            
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              
              style="
                height: 240px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">本月巡检完成率</el-col>
                  </div>
                   <div>
                    <el-col :span="8">
                      <i class="el-icon-more" style="float:right" @click="add_ins_tab()" @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :class="{ 'hovered': isHovered }"></i>
                    </el-col>
                  </div>
                </el-row>
                
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="4">
                      <el-avatar style="background: rgba(182, 32, 224, 1);"  shape="square" :size="50">
                        <i :class="['el-icon-font','el-icon-xunjian']"></i>
                      </el-avatar>
                    </el-col>
                    <el-col :span="20">
                      <span style="font-size: 40px; margin-left: 20px;">{{info.insFinishRatio}}%</span>
                    </el-col>
                  </div>
                </el-row>
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="12">
                      <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">巡检计划：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.insCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                    <el-col :span="12">
                     <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">完成巡检：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.monthHappenInsCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                  </div>
                </el-row>
            
              </el-col>
               <div id="insChart"
                     style="height:100%;width:100%;margin-top: 120px;"></div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
            
              style="
                height: 240px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">本月任务完成率</el-col>
                  </div>
                   <div>
                    <el-col :span="8">
                      <i class="el-icon-more" style="float:right" @click="add_task_tab()" @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :class="{ 'hovered': isHovered }"></i>
                    </el-col>
                  </div>
                </el-row>
                
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="4">
                      <el-avatar style="background: rgba(74, 184, 255, 1);"  shape="square" :size="50">
                         <i :class="['el-icon-font','el-icon-task']"></i>
                      </el-avatar>
                    </el-col>
                    <el-col :span="20">
                      <span style="font-size: 40px; margin-left: 20px;">{{info.taskFinishRatio}}%</span>
                    </el-col>
                  </div>
                </el-row>
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="12">
                      <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">任务数量：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.taskCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                    <el-col :span="12">
                     <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">完成任务：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.monthHappenTaskCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
              
              <div id="taskChart"
                     style="height:100%;width:100%;margin-top: 120px;">
                     </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card
              class="card"
              style="
                height: 240px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">本月保养完成率</el-col>
                  </div>
                   <div>
                    <el-col :span="8">
                      <i class="el-icon-more" style="float:right" @click="add_maintain_tab()" @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :class="{ 'hovered': isHovered }"></i>
                    </el-col>
                  </div>
                </el-row>
                
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="4">
                      <el-avatar style="background: rgba(32, 224, 165, 1)" shape="square" :size="50">
                         <i :class="['el-icon-font','el-icon-yiyaoxiang']"></i>
                      </el-avatar>
                    </el-col>
                    <el-col :span="20">
                      <span style="font-size: 40px; margin-left: 20px;">{{info.maintainFinishRatio}}%</span>
                    </el-col>
                  </div>
                </el-row>
                <el-row style="margin-top: 10px">
                   <div>
                    <el-col :span="12">
                      <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">保养计划：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.maintainCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                    <el-col :span="12">
                     <el-row>
                  <div>
                    <el-col :span="13" class="tatistic-key">完成保养：</el-col>
                    <el-col :span="11" class="tatistic-value">
                      <div>
                        {{info.monthHappenMaintainCount}}
                      </div>
                    </el-col>
                  </div>
                </el-row>
                    </el-col>
                  </div>
                </el-row>
              
              </el-col>
              <div id="maintainChart"
                     style="height:100%;width:100%;margin-top: 120px;"></div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
      
    </el-row>
    <el-row :gutter="15" style="margin-top: 20px">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-card
              class="card"
              
              style="
                height: 150px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
            <el-col>
              <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">今日数据</el-col>
                  </div>
                   
                </el-row>

                 <el-row :gutter="35" style="margin-top: 20px;text-align: center;">
                  <div style="margin-left: -35px;">
                    <el-col :span="3">
                     <div >
                        <el-row class="context-value">
                          {{info.todayHappenFaultCount}}
                        </el-row>
                        <el-row class="context-key"> 故障 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div>
                        <el-row class="context-value">
                          {{info.todayHappenInsCount}}
                        </el-row>
                        <el-row class="context-key"> 巡检 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div>
                        <el-row class="context-value">
                          {{info.todayHappenTaskCount}}
                        </el-row>
                        <el-row class="context-key"> 任务 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div>
                        <el-row class="context-value">
                          {{info.todayHappenMaintainCount}}
                        </el-row>
                        <el-row class="context-key"> 保养 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div>
                        <el-row class="context-value">
                          {{info.todaySolveFaultCount}}
                        </el-row>
                        <el-row class="context-key"> 解决故障 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div>
                        <el-row class="context-value">
                          {{info.todaySolveInsCount}}
                        </el-row>
                        <el-row class="context-key"> 完成巡检 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div>
                        <el-row class="context-value">
                         {{info.todaySolveTaskCount}}
                        </el-row>
                        <el-row class="context-key"> 完成任务 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="3">
                     <div>
                        <el-row class="context-value">
                          {{info.todaySolveMaintainCount}}
                        </el-row>
                        <el-row class="context-key"> 完成保养 </el-row>
                      </div>
                    </el-col>
                    </div>
                </el-row>
            </el-col>
            </el-card>
          </el-col>
         
          <el-col :span="6">
            <el-card
              class="card"
              style="
                height: 150px;

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">总览信息</el-col>
                  </div>
                   
                </el-row>
                <el-row :gutter="35" style="margin-top: 5px;text-align: center;">
                  <div style="margin-left: -80px;">
                    <el-col :span="12">
                     <div>
                        <el-row style="color: rgb(0, 0, 0);
  font-size: 20px;
  margin-left: 40px;
  font-weight: bold;">
                          {{info.dutyPpersonnelCount}}
                        </el-row>
                        <el-row  style=" color: #9BA2AB;
  margin-top: 5px;
  margin-left: 40px;
  font-size: 15px;"> 人员 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div>
                        <el-row style="color: rgb(0, 0, 0);
  font-size: 20px;
  margin-left: 20px;
  font-weight: bold;">
                          {{info.orgDataAssetValue}}
                        </el-row>
                        <el-row style=" color: #9BA2AB;
  margin-top: 5px;
  margin-left: 20px;
  font-size: 15px;"> 接入车站 </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
                <el-row :gutter="35" style="margin-top: 5px;text-align: center;">
                  <div style="margin-left: -80px;">
                    <el-col :span="12">
                     <div>
                        <el-row style="color: rgb(0, 0, 0);
  font-size: 20px;
  margin-left:40px;
  font-weight: bold;">
                          {{info.userCount}}
                        </el-row>
                        <el-row  style=" color: #9BA2AB;
  margin-top: 5px;
  margin-left: 40px;
  font-size: 15px;"> 接入人员 </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div>
                        <el-row style="color: rgb(0, 0, 0);
  font-size: 20px;
  margin-left: 20px;
  font-weight: bold;">
                         {{info.assetCount}}
                        </el-row>
                        <el-row style=" color: #9BA2AB;
  margin-top: 5px;
  margin-left: 20px;
  font-size: 15px;"> 接入设备 </el-row>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </el-col>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="15" style="margin-top: 20px">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-card
            
              class="card1"
              style="
                height: calc(100vh - 552px);
                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
  <el-tab-pane label="实时故障" name="fault">
    <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="height: calc(100vh - 620px)">
                <!-- height="calc(100vh - 805px)" -->
                <el-table
                  :data="filteredData"
                  ref="fauTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 620px)"
                  style="overflow: auto"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="code" label="故障单号"> </el-table-column>
            <el-table-column prop="system_name" label="系统专业">
            </el-table-column>
            <el-table-column prop="org_name" label="所属组织"> </el-table-column>
            <el-table-column prop="equi_name" label="设备名称">
            </el-table-column>
                  <el-table-column
                    prop="appeName"
                    :show-overflow-tooltip="true"
                    label="故障现象"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        scope.row.appe_id == 999999
                          ? scope.row.des == null
                            ? ""
                            : scope.row.des
                          : scope.row.appe_name
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="duration" label="规定完成时长">
                    <template slot-scope="scope">
                      <span style="color: orange"
                        >{{ scope.row.duration }}小时</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="plan_solve_time" label="规定完成时间">
                    <template slot-scope="scope">
                      <span style="color: orange">{{
                        scope.row.plan_solve_time
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="occu_time" label="故障上报时间">
                  </el-table-column>
                  <el-table-column
                    prop="state"
                    label="状态"
                    width="165"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="stateFormat(scope.row, 1)">{{
                        scope.row.statename
                      }}</el-tag>
                      <el-tag
                        size="mini"
                        type="danger"
                        style="margin-left: 4px"
                        v-if="
                          scope.row.process != null &&
                          scope.row.process.startsWith('挂起')
                        "
                        >挂起</el-tag
                      >
                      <el-tag
                  size="mini"
                  type="danger"
                  v-if="scope.row.response_time!=null && changeOutTime(scope.row) > scope.row.response_time"
                  >已超时</el-tag
                >
                    </template>
                  </el-table-column>
                   <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_fau_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
  </el-tab-pane>
  <el-tab-pane label="实时巡检" name="ins"> <div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 620px)">
                <!-- height="calc(100vh - 805px)" -->

                <el-table
                  :data="filteredData"
                  ref="insTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 620px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="orgName" label="车站名称" width="100">
                  </el-table-column>
                  <el-table-column prop="lineName" label="巡检线路名称">
                  </el-table-column>
                  <el-table-column
                    prop="starttime"
                    label="开始时间"
                    width="140"
                  >
                  </el-table-column>
                  <el-table-column prop="endtime" label="结束时间" width="140">
                  </el-table-column>
                  <el-table-column
                    prop="inspeopleName"
                    label="巡检人员"
                    width="80"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="inscount"
                    label="完成/总数"
                    align="center"
                    width="80"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.finishCount == null"
                        >0/{{ scope.row.totalCount }}</span
                      >
                      <span v-else>
                        {{ scope.row.finishCount }}/{{ scope.row.totalCount }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="finishTime"
                    label="最后执行时间"
                    width="140"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="states"
                    label="是否分配"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.inspeopleId != null &&
                          scope.row.inspeopleId != ''
                        "
                        size="mini"
                        type="success"
                        >已分配</el-tag
                      >
                      <el-tag v-else size="mini" type="warning">未分配</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="states" label="状态" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="showState(scope.row)">{{
                        scope.row.statename
                      }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="faultcode"
                    label="故障状态"
                    width="80"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.faultCode == null ||
                          scope.row.faultCode == ''
                        "
                        slot="reference"
                        size="mini"
                        type="success"
                        >正常</el-tag
                      >

                      <el-popover v-else placement="top">
                        <p>&nbsp;&nbsp;故障编码</p>
                        <div style="text-align: center; margin: 10">
                          <el-link
                            v-for="(item, index) in scope.row.faultCodelist"
                            :key="index"
                            @click="viewFaultInfo(item)"
                            icon="el-icon-warning"
                            type="danger"
                            >{{ item }}&nbsp;</el-link
                          >
                          <br />
                          <br />
                        </div>
                        <el-tag slot="reference" size="mini" type="danger"
                          >故障</el-tag
                        >
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_ins_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div></el-tab-pane>
  <el-tab-pane  name="task" label="实时任务"><div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 620px)">
                <!-- height="calc(100vh - 805px)" -->

                <el-table
                  :data="filteredData"
                  ref="maintainTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 620px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column prop="name" label="任务名称">
                  </el-table-column>
                  <el-table-column prop="orgName" label="组织">
                  </el-table-column>
                  <el-table-column prop="systemName" label="系统专业">
                  </el-table-column>
                  <el-table-column prop="chargePersonName" label="责任人">
                  </el-table-column>
                  <el-table-column prop="planStartTime" label="计划开始时间">
                  </el-table-column>
                  <el-table-column prop="planEndTime" label="计划结束时间">
                  </el-table-column>

                  <el-table-column
                    prop="state"
                    label="状态"
                    width="82"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        size="mini"
                        :type="taskStateFormat(scope.row, 1)"
                        >{{ scope.row.statename }}</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_task_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div></el-tab-pane>
  <el-tab-pane label="实时保养" name="maintain"><div>
              <!-- height: calc(100vh - 780px); -->
              <el-card style="overflow-y: auto; height: calc(100vh - 620px)">
                <!-- height="calc(100vh - 805px)" -->

                <el-table
                  :data="filteredData"
                  ref="maintainTable"
                  show-overflow-tooltip
                  border
                  stripe
                  size="mini"
                  v-loading="loading"
                  height="calc(100vh - 620px)"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                  >
                  </el-table-column>
                 <el-table-column prop="name" label="保养任务名称">
            </el-table-column>
            <el-table-column prop="orgName" label="组织">
            </el-table-column>
            <el-table-column prop="systemName" label="系统专业" width="80">
            </el-table-column>
            <el-table-column prop="assetTypeName" label="设备类型" width="90">
            </el-table-column>
                
                  <el-table-column
                    prop="planStartTime"
                    label="计划开始时间"
                    width="140"
                  >
                  </el-table-column>
                  <el-table-column prop="planEndTime" label="计划结束时间" width="140">
                  </el-table-column>
                  
                  <el-table-column
                    prop="inscount"
                    label="完成/总数"
                    align="center"
                    width="80"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.finishCount == null"
                        >0/{{ scope.row.totalCount }}</span
                      >
                      <span v-else>
                        {{ scope.row.finishCount }}/{{ scope.row.totalCount }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="finishTime"
                    label="最后执行时间"
                    width="140"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="states"
                    label="是否分配"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.inspeopleId != null &&
                          scope.row.inspeopleId != ''
                        "
                        size="mini"
                        type="success"
                        >已分配</el-tag
                      >
                      <el-tag v-else size="mini" type="warning">未分配</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="states" label="状态" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="showState(scope.row)">{{
                        scope.row.statename
                      }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="faultcode"
                    label="故障状态"
                    width="80"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-tag
                        v-if="
                          scope.row.faultCode == null ||
                          scope.row.faultCode == ''
                        "
                        slot="reference"
                        size="mini"
                        type="success"
                        >正常</el-tag
                      >

                      <el-popover v-else placement="top">
                        <p>&nbsp;&nbsp;故障编码</p>
                        <div style="text-align: center; margin: 10">
                          <el-link
                            v-for="(item, index) in scope.row.faultCodelist"
                            :key="index"
                            @click="viewFaultInfo(item)"
                            icon="el-icon-warning"
                            type="danger"
                            >{{ item }}&nbsp;</el-link
                          >
                          <br />
                          <br />
                        </div>
                        <el-tag slot="reference" size="mini" type="danger"
                          >故障</el-tag
                        >
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="60" align="center">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        title="详情"
                        @click="add_maintain_tab(scope.row)"
                        type="primary"
                        ><i class="el-icon-font el-icon-view"></i
                      ></el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div></el-tab-pane>
</el-tabs>
            </el-card>
          </el-col>
         
          <el-col :span="6">
            <el-card
              class="card"
              style="
                height: calc(100vh - 552px);

                background-size: 100% 100%;
                background-repeat: no-repeat;
                overflow: hidden;
                border-radius: 10px;
              "
            >
              <el-col>
                <el-row>
                  <div>
                    <el-col :span="16" class="tatistic-title">通知公告</el-col>
                  </div>
                    <div>
                    <el-col :span="8"><span style="color: #74798C;
  font-size: 14px;
  float: right;" @click="add_notice_tab" @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      :class="{ 'hovered': isHovered }">查看全部 ></span></el-col>
                  </div>
                </el-row>

                <div  v-for="(item, index) in notices"
              :key="index">
                <el-row style="margin-top: 40px">
                  <div>
                    <el-col :span="6">
                        <div class="block"><el-avatar shape="square" :size="70" :src="item.imgurl"></el-avatar></div>
                    </el-col>
                  </div>
                  <div>
                    <el-col :span="18">
                      <el-row>
                        <span>{{ item.title }}</span>
                      </el-row>
                       <el-row style="margin-top: 25px">
                        <span>{{ item.create_time }}</span>
                      </el-row>
                    </el-col>
                  </div>
                </el-row>
                </div>      
              </el-col>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dateutils from "../utils/dateutils.js";

import "ol/ol.css";
// import { Style, Circle, Fill } from "ol/style"

export default {
  name: "eshome",
  
  data() {
    return {
      
      loading: false,
      queryObj: { starttime: [], endtime: [] }, //查询条件
      dayFaultHis: [],
      faultlist: [], //故障列表
      inslist: [], //巡检数据
      maintain: [], //保养数据
      tasklist: [], //任务数据
      repairlist: [], //维修数据
      info: {}, //总览数据
      wrnameData: [],
      wrnameDataMess: {},
      map: null,
      layer: null,
      pointLayer: null,
      wrnameDataMessView: false,
      imgUrl: require("../assets/imgs/eshome.png"),
      notices: [], //通告列表
      //标题页默认选择 故障
      activeName: "fault",
      filteredData: [], // 筛选后的数据
      refreshTimer: null, // 定时刷新的定时器
      fileListView :[],
      isHovered: false,
      myfauChart: "",
      mytaskChart: "",
      myinsChart: "",
      mymaintainChart: "",
      fauchartObserver: "",
      inschartObserver: "",
      taskchartObserver: "",
      maintainchartObserver: ""
    };
  },
  methods: {
    init() {
      this.getOutlinedata();
      this.getNoticeData();
      //this.loadDayFaultHis();
    },
    getOutlinedata() {
      this.$ajax
        .get("/buss/home/getOverviewData")
        .then((msg) => {
          this.info = msg;
          this.faultlist = msg.faultList;
          this.inslist = msg.insList;
          this.maintain = msg.maintainList;
          this.tasklist = msg.taskList;
          this.repairlist = msg.repairList;
          this.filterData();
          this.initfauEChart(msg.faultChart)
          this.initinsEChart(msg.insChart)
          this.inittaskEChart(msg.taskChart)
          this.initmaintainEChart(msg.maintainChart)
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    getNoticeData() {
      this.fileListView = [];
      this.$ajax
        .get("/buss/home/getNoticeData")
        .then((msg) => {
           msg.forEach((obj) => { 
             if (obj.attach_imgs != null && obj.attach_imgs != "") {
            let temp = JSON.parse(obj.attach_imgs);
            temp.forEach((e) => {
             obj.imgurl= this.$api +
                  e.url +
                  "&platform=web&token=" +
                  this.$store.getUser().token
              
            });
             }
             console.log(obj)
          });
          this.notices = msg;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    stateFormat(row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      }
    },
    //显示状态，type=1列表用，type=2详情用
    maintainStateFormat(row, type) {
      if (row.state == 0) {
        if (type == 1) {
          row.statename = "未执行";
          return "primary";
        }
        return "未执行";
      } else if (row.state == 1) {
        if (type == 1) {
          row.statename = "部分完成";
          return "primary";
        }
        return "部分完成";
      } else {
        if (type == 1) {
          row.statename = "已完成";
          return "success";
        }
        return "已完成";
      }
    },
    taskStateFormat(row, type) {
      var nowTime = dateutils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date()); //当前时间

      if (row.state == 0 && nowTime < row.planStartTime) {
        if (type == 1) {
          row.statename = "未开启";
          return "primary";
        }
        return "未开启";
      } else if (
        row.state == 0 &&
        nowTime >= row.planStartTime &&
        nowTime <= row.planEndTime
      ) {
        if (type == 1) {
          row.statename = "执行中";
          return "primary";
        }
        return "执行中";
      } else if (
        row.state == 1 &&
        row.doneTime >= row.planStartTime &&
        row.doneTime <= row.planEndTime
      ) {
        if (type == 1) {
          row.statename = "已完成";
          return "success";
        }
        return "已完成";
      } else if (row.state == 1 && row.doneTime > row.planEndTime) {
        if (type == 1) {
          row.statename = "逾期完成";
          return "warning";
        }
        return "逾期完成";
      } else {
        if (type == 1) {
          row.statename = "未完成";
          return "danger";
        }
        return "未完成";
      }
    },
    //显示状态，type=1列表用，type=2详情用
    repairStateFormat(row, type) {
      if (row.state == 1) {
        if (type == 1) {
          row.statename = "待分配";
          return "warning";
        }
        return "待分配";
      } else if (row.state == 2) {
        if (type == 1) {
          row.statename = "待解决";
          return "primary";
        }
        return "待解决";
      } else if (row.state == 3) {
        if (type == 1) {
          row.statename = "已解决";
          return "success";
        }
        return "已解决";
      } else if (row.state == 4) {
        if (type == 1) {
          row.statename = "高价值作废";
          return "danger";
        }
        return "高价值作废";
      } else if (row.state == 5) {
        if (type == 1) {
          row.statename = "作废";
          return "danger";
        }
        return "作废";
      }
    },
    showState(row) {
      if (row.state == 2) {
        if (new Date(row.finishTime) > new Date(row.endtime)) {
          row.statename = "逾期完成";
          return "warning";
        } else {
          row.statename = "完成";
          return "success";
        }
      } else {
        if (new Date() > new Date(row.endtime)) {
          row.statename = "计划过期";
          return "danger";
        } else {
          row.statename = "未完成";
          return "primary";
        }
      }
    },
    loadDayFaultHis() {
      this.queryObj.starttime = dateutils.dateFormat(
        "YYYY-mm-01 00:00:00",
        new Date()
      );
      this.queryObj.endtime = dateutils.dateFormat(
        "YYYY-mm-dd 23:59:59",
        new Date()
      );
      this.$ajax
        .get("/buss/statisticfault/dayfaulthis", this.queryObj)
        .then((msg) => {
          this.dayFaultHis = msg;
          this.initLineDayFaultHis(this.dayFaultHis, "eleDayFaultHis", "");
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    add_fau_tab(row) {
      if (this.$store.getUser().menus.indexOf("/fault/faultquery") >= 0) {
        let param = {
          id: 48,
          label: "故障查询",
          icon: "el-icon-yulanchakan",
          url: "/fault/faultquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有故障查询权限");
      }
    },
    add_ins_tab(row) {
      if (this.$store.getUser().menus.indexOf("/ins/insquery") >= 0) {
        let param = {
          id: 52,
          label: "巡检查看",
          icon:"el-icon-jihua",
          url: "/ins/insquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有巡检查看查看权限");
      }
    },
    add_task_tab(row) {
      if (this.$store.getUser().menus.indexOf("/task/taskquery") >= 0) {
        let param = {
         id: 72,
          label: "任务查看",
          icon: "el-icon-chaxun",
          url: "/task/taskquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有任务查看权限");
      }
    },
    add_maintain_tab(row) {
      if (this.$store.getUser().menus.indexOf("/maintain/maintainquery") >= 0) {
        let param = {
        id: 92,
          label: "保养查看",
          icon: "el-icon-paibanchaxun",
          url: "/maintain/maintainquery",
        };
        if (row != null) {
          param.paramId = row.id;
        }
        this.$emit("add-tab", param);
      } else {
        this.$message.error("你没有保养查看权限");
      }
    },
  
    add_user_tab() {
      if (this.$store.getUser().menus.indexOf("/system/account") >= 0) {
        this.$emit("add-tab", {
          id: 12,
          label: "账户管理",
          icon: "el-icon-yonghu",
          url: "/system/account",
        });
      } else {
        this.$message.error("你没有账户管理权限");
      }
    },
    add_duty_tab() {
      if (
        this.$store.getUser().menus.indexOf("/rostering/rosteringnowduty") >= 0
      ) {
        this.$emit("add-tab", {
          id: 84,
          label: "在班人员",
          icon: "el-icon-jihua",
          url: "/rostering/rosteringnowduty",
        });
      } else {
        this.$message.error("你没有在班人员权限");
      }
    },
    add_notice_tab() {
      if (this.$store.getUser().menus.indexOf("/system/notice") >= 0) {
        this.$emit("add-tab", {
          id: 17,
          label: "通知公告",
          icon: "el-icon-gonggao",
          url: "/system/notice",
        });
      } else {
        this.$message.error("你没有在通知公告权限");
      }
    },
    add_asset_tab() {
      if (this.$store.getUser().menus.indexOf("/asset/asset") >= 0) {
        this.$emit("add-tab", {
          id: 21,
          label: "设备管理",
          icon: "el-icon-shebeizuguanli",
          url: "/asset/asset",
        });
      } else {
        this.$message.error("你没有设备管理权限");
      }
    },
    showInsDevicePlan(row) {
      console.log(row);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changeStatus() {
      console.log(this.value);
      console.log(this.activeName);
    },
    filterData() {
      
        // 如果筛选条件为空，显示全部数据
        if (this.activeName === "fault") {
          this.filteredData = this.faultlist;
        } else if (this.activeName === "ins") {
          this.filteredData = this.inslist;
        } else if (this.activeName === "maintain") {
          this.filteredData = this.maintain;
        } else if (this.activeName === "task") {
          this.filteredData = this.tasklist;
        }
      
    },
    changeOutTime(row) {
      console.log(row.arrive_time);
      console.log(row.occu_time);
      console.log(new Date(row.arrive_time));
      console.log(new Date(row.occu_time));
      let hours = parseInt(
        (new Date(row.arrive_time) - new Date(row.occu_time)) / (1000 * 60 * 60)
      );
      console.log(row.code + "---------------" + hours);
      //计算天数后剩余的毫秒数
      let leave1 =
        (new Date(row.arrive_time).getTime() -
          new Date(row.occu_time).getTime()) %
        (24 * 3600 * 1000);
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      let a = minutes == "0" ? hours : hours + 1;
      console.log(a);
      console.log(row.duration)
      console.log(row.response_time)
      
      return a;
    },

    initfauEChart (value) {
      this.$nextTick(() => {
      

        const data = value.map(item => item.fauRatio);
        const dateArray = value.map(item => item.Day);
        if(this.myfauChart){
            this.fauchartObserver.disconnect();
            this.myfauChart.dispose()
            this.myfauChart=undefined
        }
        this.myfauChart = this.$echarts.init(document.getElementById('fauChart'))
    
          let option = {
          
          grid: {
            show: false,
            top: '15%',
            right: '4%',
            bottom: '21%',
            left: '3.5%'
          },
          xAxis: {
              type: "category",
                    boundaryGap: false,//坐标轴两边留白策略,默认为true
                    data: dateArray,
             axisLabel: {
      interval: function(index,value) {
         if (index === 0 || index === dateArray.length - 1 || index === 14) {
          return value
        } else {
          return '';
        }
        
      }
    }       
                  
          },
          yAxis: {
            type: "value",
                    //设置分割线虚线效果
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: "dashed",
                            color: "#013A3F",
                        },
                    },
                //interval: 100, //默认会根据数据自动分割，因为此处要现实的数据在0-200之间，设为100则只显示两条分割线
                    show:false
          },
          series: [
            { 
              showSymbol: false,
              lineStyle:{
                width: 2,
                color:"#6236ff"
              },
              
              type: 'line',
              smooth: true,
              //设置面积区域为渐变效果
                        areaStyle: {
                            color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [{
          offset: 0, color: 'rgba(255, 255, 255, 1)' // 左边渐变色
        }, {
          offset: 0.5, color: 'rgba(98, 54, 255, 0.52)' // 左边渐变色
        },{
          offset: 1, color: 'rgba(98, 54, 255, 1)' // 右边渐变色
        }]
      }
                        },
              data: data,
            }
          ]
        };
        // 调用 resize() 方法以确保图表自适应
    /*window.addEventListener('resize', () => {
      myChart.resize();
    });*/
     
      this.myfauChart.setOption(option)
 this.fauchartObserver = new ResizeObserver(() => {
    this.myfauChart.resize();
}); 
this.fauchartObserver.observe(document.getElementById('fauChart'));
      })

    },

    initinsEChart (value) {
      this.$nextTick(() => {
         const data = value.map(item => item.fauRatio);
        const dateArray = value.map(item => item.Day);
        if(this.myinsChart){
            this.inschartObserver.disconnect();
            this.myinsChart.dispose()
            this.myinsChart=undefined
        }
        this.myinsChart = this.$echarts.init(document.getElementById('insChart'))
        var option = {
          
          grid: {
            show: false,
            top: '15%',
            right: '4%',
            bottom: '21%',
            left: '3.5%'
          },
          xAxis: {
              type: "category",
                    boundaryGap: false,//坐标轴两边留白策略,默认为true
                    data: dateArray,
             axisLabel: {
      interval: function(index,value) {
         if (index === 0 || index === dateArray.length - 1 || index === 14) {
          return value
        } else {
          return '';
        }
        
      }
    }       
                  
          },
          yAxis: {
            type: "value",
                    //设置分割线虚线效果
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: "dashed",
                            color: "#013A3F",
                        },
                    },
                //interval: 100, //默认会根据数据自动分割，因为此处要现实的数据在0-200之间，设为100则只显示两条分割线
                    show:false
          },
          series: [
            { 
              showSymbol: false,
              lineStyle:{
                width: 2,
                color:"#b620e0"
              },
              
              type: 'line',
              smooth: true,
              //设置面积区域为渐变效果
                        areaStyle: {
                            color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [{
          offset: 0, color: 'rgba(182, 32, 224, 0)' // 左边渐变色
        }, {
          offset: 0.5, color: 'rgba(183, 31, 224, 0.43)' // 左边渐变色
        },{
          offset: 1, color: 'rgba(182, 32, 224, 0.61)' // 右边渐变色
        }]
      }
                        },
              data: data,
            }
          ]
        };
        this.myinsChart.setOption(option)
       this.inschartObserver = new ResizeObserver(() => {
    this.myinsChart.resize();
});
this.inschartObserver.observe(document.getElementById('insChart'));
      })

    },

     inittaskEChart (value) {
      this.$nextTick(() => {
        const data = value.map(item => item.fauRatio);
        const dateArray = value.map(item => item.Day);
         if(this.mytaskChart){
            this.taskchartObserver.disconnect();
             this.mytaskChart.dispose()
            this.mytaskChart=undefined
        }
        this.mytaskChart = this.$echarts.init(document.getElementById('taskChart'))
        var option = {
          
          grid: {
            show: false,
             top: '15%',
            right: '4%',
            bottom: '21%',
            left: '3.5%'
          },
          xAxis: {
              type: "category",
                    boundaryGap: false,//坐标轴两边留白策略,默认为true
                    data: dateArray,
             axisLabel: {
      interval: function(index,value) {
         if (index === 0 || index === dateArray.length - 1 || index === 14) {
          return value
        } else {
          return '';
        }
        
      }
    }       
                  
          },
          yAxis: {
            type: "value",
                    //设置分割线虚线效果
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: "dashed",
                            color: "#013A3F",
                        },
                    },
                //interval: 100, //默认会根据数据自动分割，因为此处要现实的数据在0-200之间，设为100则只显示两条分割线
                    show:false
          },
          series: [
            { 
              showSymbol: false,
              lineStyle:{
                width: 2,
                color:"#5ebefc"
              },
              
              type: 'line',
              smooth: true,
              //设置面积区域为渐变效果
                        areaStyle: {
                            color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [{
          offset: 0, color: 'rgba(74, 184, 255, 0)' // 左边渐变色
        }, {
          offset: 0.5, color: 'rgba(74, 183, 255, 0.35)' // 左边渐变色
        },{
          offset: 1, color: 'rgba(74, 184, 255, 1)' // 右边渐变色
        }]
      }
                        },
              data: data,
            }
          ]
        };
        this.mytaskChart.setOption(option)
        this.taskchartObserver = new ResizeObserver(() => {
        this.mytaskChart.resize();
});
this.taskchartObserver.observe(document.getElementById('taskChart'));
      })

    },

    initmaintainEChart (value) {
      this.$nextTick(() => {
        const data = value.map(item => item.fauRatio);
        const dateArray = value.map(item => item.Day);
        console.log(dateArray)
        if(this.mymaintainChart){
            this.maintainchartObserver.disconnect();
            this.mymaintainChart.dispose()
            this.mymaintainChart=undefined
        }
        this.mymaintainChart = this.$echarts.init(document.getElementById('maintainChart'))
        var option = {
          
          grid: {
            show: false,
             top: '15%',
            right: '4%',
            bottom: '21%',
            left: '3.5%'
          },
          xAxis: {
              type: "category",
                    boundaryGap: false,//坐标轴两边留白策略,默认为true
                    data: dateArray,
             axisLabel: {
      interval: function(index,value) {
         if (index === 0 || index === dateArray.length - 1 || index === 14) {
          return value
        } else {
          return '';
        }
        
      }
    }       
                  
          },
          yAxis: {
            type: "value",
                    //设置分割线虚线效果
                    splitLine: {
                        show: false,
                        lineStyle: {
                            type: "dashed",
                            color: "#013A3F",
                        },
                    },
                //interval: 100, //默认会根据数据自动分割，因为此处要现实的数据在0-200之间，设为100则只显示两条分割线
                    show:false
          },
          series: [
            { 
              showSymbol: false,
              lineStyle:{
                width: 2,
                color:"#51cca3"
              },
              
              type: 'line',
               smooth: true,
              //设置面积区域为渐变效果
                        areaStyle: {
                            color: {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 1,
        y2: 0,
        colorStops: [{
          offset: 0, color: 'rgba(145, 255, 102, 0)' // 左边渐变色
        }, {
          offset: 0.5, color: 'rgba(72, 208, 162, 0.08)' // 左边渐变色
        },{
          offset: 1, color: 'rgba(57, 227, 170, 0.13)' // 右边渐变色
        }]
      }
                        },
              data: data,
            }
          ]
        };
        this.mymaintainChart.setOption(option)
        this.maintainchartObserver = new ResizeObserver(() => {
    this.mymaintainChart.resize();
});
this.maintainchartObserver.observe(document.getElementById('maintainChart'));
      })
},
handleMouseEnter() {
    this.isHovered = true;
  },
  handleMouseLeave() {
    this.isHovered = false;
  },
  },

  created() {
    this.init();
    this.refreshTimer = setInterval(() => {
      this.init();
    }, 30000); // 30秒刷新一次
  },
  beforeDestroy(){
    clearInterval(this.refreshTimer);
  },
  watch: {
    activeName() {
      this.filterData();
     
    },
  },
};
</script>

<style  scoped>
.card-context {
  height: 200px;
}

.title-context {
  height: 160px;
  border-radius: 10px;
  margin-top: 10px;
}

.context-div {
  margin-left: 10px;
  margin-top: 10px;
  text-align: center;
}

.context-value {
  color: rgb(0, 0, 0);
  font-size: 25px;
  margin-left: 20px;
  font-weight: bold;
  
}

.context-key {
  color: #9BA2AB;
  margin-top: 10px;
  margin-left: 20px;
  font-size: 15px;
}

.tatistic-div {
  height: 85px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 5px;
  text-align: center;
}

.tatistic-dialog-div {
  height: 85px;
  background: #e5d7f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-value {
  color: #9BA2AB;
  /* text-align: right; */

  font-size: 17px;
}

.tatistic-key {
  color: #9BA2AB;
  /* text-align: right; */

  font-size: 17px;
}

.context-icon {
  font-size: 40px;
  font-weight: 500;
  margin-top: -20px;
  margin-right: -10px;
}

.card-table {
  height: calc(100vh - 730px);
}

.card-con {
  height: calc(100vh - 350px);
}

.el-aside {
  /* background-color: #8dccf7; */
  color: rgb(255, 255, 255);
  text-align: center;
  line-height: 90px;
}

.el-main {
  /* background-color: #a2d7f9; */
  color: rgb(247, 251, 251);
  text-align: center;
  line-height: 50px;
}

.map {
  height: 390px;
  width: 100%;
  box-shadow: 0 0 0 0 rgb(0 0 0 / 10%);
  background-color: #fff;
  transition: 0.3s;
  overflow: hidden;
}

.tatistic-title {
  color: #74798C;
  font-size: 17px;
  margin-top: 0px;
}

.notice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

.title {
  font-size: 13px;
  color: #5c5c5c;
}

.time {
  font-size: 13px;
  color: #5c5c5c;
}

.circle-container {
  height: 150px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
}

.main /deep/ .el-tabs__nav-scroll {
  background-color: #3dc3f6;
}

.main /deep/ .el-tabs__item.is-active {
  color: #000000 !important;
}

.main /deep/ .el-tabs__item {
  color: #fff;
  font-weight: bold;
}

.main /deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px solid #e4e7ed;
}

.main /deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: 0px solid transparent;
  border-left: 0px solid #e4e7ed;
}

.tab-divider {
  border-top: 0px solid;
  border-bottom: 0px solid;
  padding: 1px;
  pointer-events: none;
  /* 设置不参与点击事件 */
}

.tab-title {
  margin-left: -30px;
}

.title-divider {
  background-color: #0e76ed;
  border-top: 0px solid;
  border-bottom: 0px solid;
  padding: 1px;
  top: -1px;
}

.main /deep/ .el-card__header {
  position: sticky;
  top: 0;
  z-index: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice {
  overflow: auto;
  height: 260px;
}

.option {
  float: right;
  clear: left;
}

.main /deep/ .el-tabs__header.is-top {
  background-color: #3dc3f6;
  overflow: hidden;
}

.main /deep/ .el-input__inner {
  height: 35px;
  background-color: #3dc3f6;
  margin-right: 50px;
  border: 0px solid #ffffff;
  border-radius: 0px;
  color: #ffffff;
  font-weight: bold;
}

.main /deep/ .el-icon-arrow-up:before {
  color: #ffffff;
}

.circle {
  height: 140px;
  width: 200px;
  transform-origin: center;
  transition: transform 0.5s ease-out;
}

.card:hover .circle {
  transform: scale(0.9);
}
.red{
  color:red;
}
.card1 /deep/ .el-card__body  {
  padding: 0px;
}
.hovered {
  cursor: pointer;
}
.fauavater /deep/ .el-avatar  {
  background: #0e76ed;
}
</style>
